
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/snapchat",
      function () {
        return require("private-next-pages/destinations/snapchat.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/snapchat"])
      });
    }
  